import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { MapPin, Plus, X } from "@phosphor-icons/react";

export default function FieldOps() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const load = async () => { const { data } = await api.get("/field-tasks"); setItems(data); };
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-5" data-testid="fieldops-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="label-eyebrow">Tap2Verify · Field operations</div>
          <h1 className="font-display text-[28px] font-bold tracking-tight mt-1">Field Tasks</h1>
        </div>
        <button data-testid="new-task-btn" onClick={() => setOpen(true)} className="span-btn"><Plus size={14}/> New task</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(t => (
          <div key={t.task_id} className="card-flat p-4">
            <div className="flex items-center justify-between">
              <span className={`badge ${t.priority === "high" ? "badge-danger" : t.priority === "low" ? "badge-success" : "badge-warn"}`}>{t.priority}</span>
              <span className={`badge ${t.status === "completed" ? "badge-success" : "badge-info"}`}>{t.status}</span>
            </div>
            <div className="font-display font-semibold text-[15px] mt-3">{t.title}</div>
            <div className="text-[12px] text-[var(--span-text-2)] mt-1 flex items-center gap-1"><MapPin size={11}/> {t.location}</div>
            <div className="text-[11px] text-[var(--span-text-2)] mt-3">Assigned: <span className="font-mono">{t.assigned_to}</span></div>
            <div className="text-[10px] text-[var(--span-text-2)] mt-1 font-mono">{fmtDate(t.created_at)}</div>
            {t.status !== "completed" && (
              <button data-testid={`complete-${t.task_id}`} onClick={async () => { await api.post(`/field-tasks/${t.task_id}/complete`); load(); }} className="span-btn span-btn-ghost h-7 text-[11px] mt-3 w-full">Mark complete</button>
            )}
          </div>
        ))}
      </div>

      {open && <NewTask onClose={() => setOpen(false)} onCreated={() => { setOpen(false); load(); }} />}
    </div>
  );
}

function NewTask({ onClose, onCreated }) {
  const [f, setF] = useState({ title: "", location: "", assigned_to: "", priority: "medium", instructions: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/field-tasks", f); onCreated(); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
      <form onSubmit={submit} className="card-flat w-full max-w-[480px]">
        <div className="px-5 py-4 border-b border-[var(--span-border)] flex items-center justify-between">
          <div className="font-display font-bold text-[17px]">New field task</div>
          <button type="button" onClick={onClose}><X size={18}/></button>
        </div>
        <div className="p-5 space-y-3">
          <input data-testid="task-title" required value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} placeholder="Task title" className="span-input" />
          <input required value={f.location} onChange={(e) => setF({ ...f, location: e.target.value })} placeholder="Location" className="span-input" />
          <input required value={f.assigned_to} onChange={(e) => setF({ ...f, assigned_to: e.target.value })} placeholder="Assigned to" className="span-input" />
          <select value={f.priority} onChange={(e) => setF({ ...f, priority: e.target.value })} className="span-input">
            <option>low</option><option>medium</option><option>high</option>
          </select>
          <textarea value={f.instructions} onChange={(e) => setF({ ...f, instructions: e.target.value })} placeholder="Instructions" className="span-input min-h-[80px]" />
        </div>
        <div className="px-5 py-4 border-t border-[var(--span-border)] flex justify-end gap-2">
          <button type="button" onClick={onClose} className="span-btn span-btn-ghost">Cancel</button>
          <button disabled={busy} className="span-btn">{busy ? "Saving…" : "Create"}</button>
        </div>
      </form>
    </div>
  );
}
